<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre">
<div class="pre" id="pre-001">
<h1 class="pre_tit"><span><a id="page_VIII"></a><a class="renvlnk" id="R_VIII">ILLUSTRATIONS</a></span></h1><a class="renvlnk" id="R_VIII">
</a><div class="dev"><a class="renvlnk" id="R_VIII">
</a><div class="niv1" id="niv1-001"><a class="renvlnk" id="R_VIII">
<h2 class="int_niv1">MAPS</h2>
</a><p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><a class="renvlnk" id="R_VIII"></a><span class="renv" href="#/chap2#fig-001" title="Link target outside of Sample">1  The Assyrian empire</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap3#fig-002" title="Link target outside of Sample">2  Israel’s tribal territories</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap5#fig-003" title="Link target outside of Sample">3  David’s kingdom</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap6#fig-004" title="Link target outside of Sample">4  The kingdoms of Israel and Judah</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap6#fig-005" title="Link target outside of Sample">5  The Babylonian empire</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap9#fig-006" title="Link target outside of Sample">6  The Persian empire</span></p>
</div>
<div class="niv1" id="niv1-002">
<h2 class="int_niv1">TABLES</h2>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap4#tab-012" title="Link target outside of Sample">1  The judges of Israel</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap4#tab-015" title="Link target outside of Sample">2  Recurrence of elements in subsequent accounts</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap4#tab-016" title="Link target outside of Sample">3  The minor judges</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap4#tab-017" title="Link target outside of Sample">4  Kitchen’s chronology of the judges period</span></p>
<p class="txt_courant_ssalinea retrait_ligne2etsuivantes"><span class="renv" href="#/chap5#tab-020" title="Link target outside of Sample">5  Thematically related episodes in 1 Samuel 24—26</span></p>
</div>
</div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre2.vue?41614961